import { render, staticRenderFns } from "./my.vue?vue&type=template&id=d4e76430&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"
import style0 from "./my.vue?vue&type=style&index=0&id=d4e76430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e76430",
  null
  
)

/* custom blocks */
import block0 from "./my.vue?vue&type=custom&index=0&blockType=el-dialog&title=%E5%8F%91%E5%B8%83%E6%96%B0%E8%AF%BE%E7%A8%8B&%3Avisible.sync=showPublishCourseDialog&width=90%25&center=true"
if (typeof block0 === 'function') block0(component)
import block1 from "./my.vue?vue&type=custom&index=1&blockType=el-dialog&%3Atitle=(currentCourse%20%26%26%20'%E3%80%90'%20%2B%20currentCourse.name%20%2B%20'%E3%80%91')%20%2B%20'%E7%AB%A0%E8%8A%82%E7%AE%A1%E7%90%86'&%3Avisible.sync=showChapterDialog&width=90%25&center=true"
if (typeof block1 === 'function') block1(component)
import block2 from "./my.vue?vue&type=custom&index=2&blockType=el-dialog&%3Atitle=chapterForm.id%20%3F%20'%E7%BC%96%E8%BE%91%E7%AB%A0%E8%8A%82'%20%3A%20'%E6%B7%BB%E5%8A%A0%E7%AB%A0%E8%8A%82'&%3Avisible.sync=showChapterFormDialog&width=90%25&center=true"
if (typeof block2 === 'function') block2(component)

export default component.exports